import React from "react";
import { EventDispatch, IEventDispatch } from "../utilities/dispatch";

export const EventContext = React.createContext<IEventDispatch>(new EventDispatch());
